import Grid from '@material-ui/core/Grid'
import Input from 'Components/Input'
import ListingModal from 'Components/ListingModal'
import Search from 'Components/Search'
import Select from 'Components/Select'
import { Emoji } from 'emoji-mart'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import DataComponent from 'EurestoComponents/DataComponents'
import Constants from 'EurestoFonction/Constants'
import React, { useEffect, useState } from 'react'

export default React.memo(props => <Search limit={50} all raz={true} defaultSearch={props.defaultSearch} group_by={props.group_by}
                                           path={'sdd'} requete={Constants.donnee.dossier} module={Constants.module.SDD}
                                           search={props.search || ((props.searchName || 'cas_' ) + (props.name || '') + User.Entite.get().id)}>
    <SearchForm/>
  </Search>
)

const SearchForm = React.memo(props => {

  const [search, setSearch] = useState(props.search || {})

  const [groupeUserOptions, setGroupeUserOptions] = useState([])
  const [userOptions, setUserOptions] = useState([])
  useEffect(() => {
    const regroupement = Data.list(Constants.module.CONFIGURATION, Constants.donnee.groupe_utilisateur)
    const utilisateurs = Data.list(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, {
      civilite_id: {
        not: true,
        value: null
      }
    })
    let options = []
    regroupement.map(grp => {
      options.push({
        label: grp.libelle,
        value: grp.id,
        html: <strong>{grp.libelle}</strong>,
        archive_id: !grp.actif
      })

      options = options.concat((grp.utilisateurs || []).map(uid => ({
        label: (utilisateurs.find(u => u.id === uid) || {}).slibelle,
        html: <span style={{ paddingLeft: 5 }}>{(utilisateurs.find(u => u.id === uid) || {}).slibelle}</span>,
        value: uid,
        archive_id: (utilisateurs.find(u => u.id === uid) || {}).archive_id,
        groupe_id: grp.id
      })))
    })
    if ((utilisateurs || []).length > 0) {
      options.push({
        label: 'Utilisateurs',
        html: <Grid container onClick={e => e.stopPropagation()}
                    style={{ cursor: 'not-allowed', width: '100%', margin: 0, padding: 0 }} justify={'center'}
                    alignItems={'center'}><strong>Utilisateurs</strong></Grid>,
        value: null
      })
    }
    utilisateurs.map(user => {
      options.push({
        label: user.slibelle,
        value: user.id,
        archive_id: user.archive_id
      })
    })
    setGroupeUserOptions(options)
    setUserOptions(utilisateurs.map(user => ({
      label: user.libelle,
      value: user.id
    })))
  }, [])

  const searching = (data, name) => {
    const srh = {
      ...(search || {}),
      [name]: data
    }
    setSearch(srh)
    props.searching && props.searching(srh)
  }

  return (
    <Grid container spacing={0} style={{ margin: 0, padding: 5 }} justify={'flex-start'}
          alignItems={'stretch'}
          alignContent={'flex-start'}
          direction={'column'}>
      <DataComponent
        htmlOptions={(data) =>
          <Grid container alignItems={'center'} justify={'center'}>
            <Emoji emoji={data.icon} size={16}/>&nbsp;
            {data.libelle}
          </Grid>}
        title={EurestoI18n.t('crm:Flags')}
        name="flag_id"
        type={Constants.typeSaisie.ComboMulti}
        onChange={searching}
        data={search.flag_id}
        object={Constants.donnee.flag}
        module={Constants.module.SDD}
      />
      <ListingModal
        hideHeader
        style={{
          //height: User.CalculHeight.getHeightWanted(300),
          maxHeight: User.CalculHeight.getHeightWanted(300)
        }}
        title={EurestoI18n.t('crm:Assignée à')}
        data={groupeUserOptions}
        onClick={searching}
        name={'user_assign_id'}
        value={search.user_assign_id}
        libelle={search.user_assign_id && (groupeUserOptions.find(g => g.value === search.user_assign_id) || {}).label}/>
      <ListingModal
        hideHeader
        style={{
          //height: User.CalculHeight.getHeightWanted(300),
          maxHeight: User.CalculHeight.getHeightWanted(300)
        }}
        title={EurestoI18n.t('crm:Créée par')}
        data={userOptions || []}
        onClick={searching}
        name={'user_id'}
        value={search.user_id}
        libelle={search.user_id && ((userOptions || []).find(g => g.value === search.user_id) || {}).label}/>
      <Input title={EurestoI18n.t('crm:Nom Ticket')}
             name="libelle"
             onChange={searching}
             value={search['libelle']}/>
      <Input title={EurestoI18n.t('crm:Message')}
             name="message"
             onChange={searching}
             value={search['message']}/>
      <Select title={EurestoI18n.t('crm:Fermé')} name="?actif"
              autoComplete={false}
              onChange={searching}
              value={search['?actif']}
              options={[{
                value: -1,
                label: 'Oui'
              }, {
                value: 1,
                label: 'Non'
              }]}/>
    </Grid>
  )
})


// WEBPACK FOOTER //
// ./app/App/Module/SDD/Component/Cas/Search/index.js